<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ModalTitle from "%/dynamic-component-editor/options/modal-title";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";

// Editor twin draws the contents inline so they stay editable; staging opens them as a modal on the bound field.
export default {
  name: "EntityModalContainer",
  extends: Container,
  mixins: [DynamicElementWithContext],
  elementPanelSettings: {
    alias: "Modal Container",
    displayName: "Modal",
    displayIcon: "mdi:dock-window",
    tags: ["container", "modal", "dialog", "popup"],
  },
  hidden: true,
  options: [
    ModalTitle,
  ],
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    SpacingOptions,
    AppearanceOptions,
  ],
};
</script>
